export default __webpack_public_path__ + "static/media/error-512.a63f69ca.png";